window.CONFIG_COMPONENTS = {
  case: {
    case_steel_fluted: "{{ 'case_steel_fluted.png' | asset_url }}",
    case_rose_fluted: "{{ 'case_rose_fluted.png' | asset_url }}"
  },

  dial: {
    dial_skyblue_arabic: "{{ 'dial_skyblue_arabic.png' | asset_url }}",
    dial_black_roman: "{{ 'dial_black_roman.png' | asset_url }}"
  },

  hands: {
    hands_silver_baton: "{{ 'hands_silver_baton.png' | asset_url }}",
    hands_rose_baton: "{{ 'hands_rose_baton.png' | asset_url }}"
  },

  strap: {
    strap_steel_jub: "{{ 'strap_steel_jub.png' | asset_url }}",
    strap_rose_jub: "{{ 'strap_rose_jub.png' | asset_url }}"
  },

  cyclops: {
    with: "{{ 'cyclops_with.png' | asset_url }}"
  }
};
